import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Label,
    Spinner,
    Progress,
    Table,
    Input,
    Alert
} from "reactstrap"
import { accessRole } from '../../../../helpers/access_role'
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import YearSelect from '../../../../helpers/ui/YearSelect'
import Select from '../../../../helpers/ui/CustomSelect'
import { AvForm, AvField, AvGroup, AvCheckboxGroup, AvCheckbox, AvInput } from "availity-reactstrap-validation"

import { Redirect, Link } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'
import { cancelToken } from '../../../../services/adapters/kepegawaian/menuService'

import CreateBloc from './Blocs/CreateBloc'
import IndexBloc from '../Index/Blocs/IndexBloc'

const reformatDate = (date, withDay = false) => {
    const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];
    const days = [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jum'at",
        "Sabtu"
    ]
    
    const d = new Date(date);

    let dt = d.getDate()
    if (dt < 10)
        dt = '0'+dt

    let day = ''
    if (withDay) {
        day = days[d.getDay()] + ", "
    }

    if (date) {
        return day + dt + " " + months[d.getMonth()] + " " + d.getFullYear();
    }

    return '-'
};


class CreateView extends Component {

    peg_uuid = !accessRole('approve') ? JSON.parse(localStorage.getItem('userdata')) != null ? JSON.parse(localStorage.getItem('userdata')).employee_uuid : ""
        : JSON.parse(localStorage.getItem('employeeSelected')) != null ? JSON.parse(localStorage.getItem('employeeSelected')).employee_uuid : ""


    source
    indexBloc = new IndexBloc()
    createBloc = new CreateBloc()
    defaultSize = 10
 
    constructor(props) {
        super(props)
        this.state = {
            detail: null,
            dataForm: {}, 
            type: null,
            loadingProcess: 0,
            familyAllowance: false
        }
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                uuid: this.peg_uuid,
                ...values
            },
            confirm: true
        })
    }


    submitData = async () => {
        await this.createBloc.fetchCreate(this.state.dataForm)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    loadLegalisir = async () => {
        const query = {
            uuid: this.peg_uuid
        }
        this.setState({ detail: null })
        await this.indexBloc.fetchFormLegalisir(query)
    }

    loadBPJS = async () => {
        const query = { 
            uuid: this.peg_uuid
        }
        this.setState({ detail: null })
        await this.indexBloc.fetchFormBPJS(query)
    }

    loadTASPEN = async () => {
        const query = { 
            uuid: this.peg_uuid
        }
        this.setState({ detail: null })
        await this.indexBloc.fetchFormTASPEN(query)
    }

    loadKP4 = async () => {
        const query = { 
            uuid: this.peg_uuid
        }
        this.setState({ detail: null })
        await this.indexBloc.fetchFormKP4(query)
    }

    componentDidMount() {

        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })


        this.indexBloc.formLegalisirChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL: 
                    this.setState({ loadingProcess: 0 })
                    break
                case apiResponse.LOADING:
                    this.setState({ loadingProcess: 10 })
                    break
                case apiResponse.COMPLETED:
                    this.setState({ loadingProcess: 100 })
                    setTimeout(() => {
                        this.setState({ detail: result.data.response, loadingProcess: 0 })
                    }, 800);
                    break
                case apiResponse.ERROR:
                    this.setState({ loadingProcess: 100 })
                    break
                default:
                    break
            }
        })

        this.indexBloc.formBPJSChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL: 
                    this.setState({ loadingProcess: 0 })
                    break
                case apiResponse.LOADING:
                    this.setState({ loadingProcess: 10 })
                    break
                case apiResponse.COMPLETED:
                    this.setState({ loadingProcess: 100 })
                    setTimeout(() => {
                        this.setState({ detail: result.data.response, loadingProcess: 0 })
                    }, 800);
                    break
                case apiResponse.ERROR:
                    this.setState({ loadingProcess: 100 })
                    break
                default:
                    break
            }
        })

        this.indexBloc.formTASPENChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL: 
                    this.setState({ loadingProcess: 0 })
                    break
                case apiResponse.LOADING:
                    this.setState({ loadingProcess: 10 })
                    break
                case apiResponse.COMPLETED:
                    this.setState({ loadingProcess: 100 })
                    setTimeout(() => {
                        this.setState({ detail: result.data.response, loadingProcess: 0 })
                    }, 800);
                    break
                case apiResponse.ERROR:
                    this.setState({ loadingProcess: 100 })
                    break
                default:
                    break
            }
        })

        this.indexBloc.formKP4Channel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL: 
                    this.setState({ loadingProcess: 0 })
                    break
                case apiResponse.LOADING:
                    this.setState({ loadingProcess: 10 })
                    break
                case apiResponse.COMPLETED:
                    this.setState({ loadingProcess: 100 })
                    setTimeout(() => {
                        this.setState({ detail: result.data.response, loadingProcess: 0 })
                    }, 800);
                    break
                case apiResponse.ERROR:
                    this.setState({ loadingProcess: 100 })
                    break
                default:
                    break
            }
        })

    }

    componentWillUnmount() {
        this.indexBloc.formLegalisirChannel?.unsubscribe()
        this.indexBloc.formBPJSChannel?.unsubscribe()
        this.indexBloc.formTASPENChannel?.unsubscribe()
        this.indexBloc.formKP4Channel?.unsubscribe()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.type != this.state.type) {
            if (this.state.type == 1) {
                this.loadLegalisir()
            }
            if (this.state.type == 2) {
                this.loadBPJS()
            }
            if (this.state.type == 3) {
                this.loadTASPEN()
            }
            if (this.state.type == 4) {
                this.loadKP4()
            }
        }
    }

    render() {
        const { type, detail } = this.state
        return (
            <Fragment>
                <Container fluid>
                    <Card>
                        <CardBody>
                            <div className="float-end">
                                <Link to='/kepegawaian/pengajuan_dokumen.html'>
                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                </Link>
                            </div>
                            <CardTitle>Buat Pengajuan Dokumen</CardTitle>
                            <hr />    
                            <AvForm
                                className="needs-validation"
                                onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                            >    
                                <Row className="mb-3">
                                    <Label className="col-md-2 col-form-label">
                                        Perihal <span className="text-danger">*</span>
                                    </Label>
                                    <Col md="3">
                                        <Select 
                                            name="online_submission_type"
                                            placeholder="Pilih perihal permohonan"
                                            errorMessage="Pilih perihal permohonan"
                                            onChange={opt => {
                                                this.setState({ type: opt.value })
                                            }}
                                            options={[
                                                { value: 1, label: "Legalisir Dokumen Kepegawaian"}, 
                                                { value: 2, label: "Pembuatan BPJS Online" }
                                                // { value: 3, label: "Pengisian KP4" }
                                            ]}
                                            validate={{ required: { value: true } }}
                                        />
                                    </Col>
                                </Row>
                                <hr/>

                                {/* Legalisir Dokumen Kepegawaian */}
                                { type == 1 &&
                                    <Fragment>
                                        {this.state.detail == null ?
                                            <Row className="mb-3">
                                                <Col md="12" style={{ marginTop: 6 }}>
                                                    <Progress value={this.state.loadingProcess} />
                                                </Col>
                                            </Row>                  
                                            :
                                            <Fragment>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Nama
                                                    </Label>
                                                    <Col md="3">
                                                        <Input
                                                            value={detail?.employee_full_name}
                                                            readOnly={true}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        NIP
                                                    </Label>
                                                    <Col md="3">
                                                        <Input
                                                            value={detail?.employee_nip}
                                                            readOnly={true}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Pangkat/Golongan   
                                                    </Label>
                                                    <Col md="3">
                                                        <Input
                                                            value={detail?.employee_current_rank_group_room}
                                                            readOnly={true}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Jabatan
                                                    </Label>
                                                    <Col md="3">
                                                        <Input
                                                            value={detail?.employee_current_position_name}
                                                            readOnly={true}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Unit Kerja
                                                    </Label>
                                                    <Col md="3">
                                                        <Input
                                                            value={detail?.employee_current_work_unit_name}
                                                            readOnly={true}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Legalisir <span className="text-danger">*</span>
                                                    </Label>
                                                    <Col md="3">
                                                        <Select 
                                                            name="online_submission_legalize_type"
                                                            placeholder="Untuk Permohonan Legalisir..."
                                                            validate={{ required: { value: true } }}                                                       
                                                            options={[
                                                                { value: 1, label: 'SK PNS' },
                                                                { value: 2, label: 'SK Pangkat' },
                                                                { value: 3, label: 'SK Jabatan' },
                                                            ]}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Keperluan <span className="text-danger">*</span>
                                                    </Label>
                                                    <Col md="3">
                                                        <AvField 
                                                            name="online_submission_purpose"
                                                            placeholder="Untuk Keperluan..."
                                                            type="textarea"
                                                            validate={{ required: { value: true } }}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Fragment>                     
                                        }
                                    </Fragment>
                                }
                                {/* END Legalisir Dokumen Kepegawaian */}


                                {/* Pembuatan BPJS Online */}
                                { type == 2 &&
                                    <Fragment>
                                        { this.state.detail == null ?
                                            <Row className="mb-3">
                                                <Col md="12" style={{ marginTop: 6 }}>
                                                    <Progress value={this.state.loadingProcess} />
                                                </Col>
                                            </Row>    
                                            :
                                            <Fragment>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Nama Lengkap
                                                    </Label>
                                                    <Col md="3">
                                                        <Input
                                                            value={detail.employee?.employee_name}
                                                            readOnly={true}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        NIP
                                                    </Label>
                                                    <Col md="3">
                                                        <Input
                                                            value={detail.employee?.employee_nip}
                                                            readOnly={true}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Tempat/Tanggal Lahir
                                                    </Label>
                                                    <Col md="3">
                                                        <Input
                                                            value={detail.employee?.employee_place_of_birth_city_name ? 
                                                                    detail.employee?.employee_place_of_birth_city_name 
                                                                    : 
                                                                    detail.employee?.employee_place_of_birth_city_text + ', ' + reformatDate(detail.employee?.employee_date_of_birth)
                                                            }
                                                            readOnly={true}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Jabatan
                                                    </Label>
                                                    <Col md="3">
                                                        <Input
                                                            value={detail.employee?.employee_current_position_name}
                                                            readOnly={true}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Unit Kerja
                                                    </Label>
                                                    <Col md="3">
                                                        <Input
                                                            value={detail.employee?.employee_current_work_unit_name}
                                                            readOnly={true}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Golongan/Ruang
                                                    </Label>
                                                    <Col md="3">
                                                        <Input
                                                            value={detail.employee?.employee_current_rank_group_room}
                                                            readOnly={true}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Susunan Keluarga
                                                    </Label>
                                                    <Col md="10">
                                                        <Table className="table table-striped table-hovered table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th width="5%">No.</th>
                                                                    <th>Nama Istri/Suami/Anak</th>
                                                                    <th>Status</th>
                                                                    <th>Tgl Lahir</th>
                                                                    <th>Kawin Tanggal</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                { detail.family?.length > 0 ?
                                                                    <Fragment>
                                                                        { detail.family?.map((val, i) => {
                                                                            return (
                                                                                <tr>
                                                                                    <td width="5%">{i+1}</td>
                                                                                    <td>{val.family_name}</td>
                                                                                    <td>{val.family_relationship_name}</td>
                                                                                    <td>{reformatDate(val.family_date_of_birth)}</td>
                                                                                    <td>{reformatDate(val.family_spouse_wedding_date)}</td>
                                                                                </tr>
                                                                            )
                                                                        }) }
                                                                    </Fragment>
                                                                    :
                                                                    <tr>
                                                                        <td colspan="5" className="text-center">Tidak ada data</td>
                                                                    </tr>
                                                                }
                                                            </tbody>
                                                        </Table>
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Alamat Sekarang
                                                    </Label>
                                                    <Col md="6">
                                                        <AvField
                                                            name="online_submission_current_address"
                                                            value={detail.employee?.employee_identity_address}
                                                            type="textarea"
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Informasi
                                                    </Label>
                                                    <Col md="8">
                                                        <Alert color="info" role="alert">
                                                            Proses Pengurusan BPJS Kesehatan dilakukan secara online melalui : Pandawa dan Chika BPJS<br/>
                                                            Pandawa (081212945526)<br/>
                                                            Chika (08118750400)<br/>
                                                            Download Kartu BPJS Kesehatan digital melalui aplikasi Mobile JKN di Playstore
                                                        </Alert>
                                                    </Col>
                                                </Row>
                                            </Fragment>
                                        }
                                    </Fragment>
                                }
                                {/* END Pembuatan BPJS Online */}

                                {/* Pengisian KP4 */}
                                { type == 3 &&
                                    <Fragment>
                                        { this.state.detail == null ?
                                            <Row className="mb-3">
                                                <Col md="12" style={{ marginTop: 6 }}>
                                                    <Progress value={this.state.loadingProcess} />
                                                </Col>
                                            </Row>        
                                            :
                                            <Fragment>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Nama Lengkap
                                                    </Label>
                                                    <Col md="3">
                                                        <Input
                                                            value={detail.employee?.employee_name}
                                                            readOnly={true}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        NIP
                                                    </Label>
                                                    <Col md="3">
                                                        <Input
                                                            value={detail.employee?.employee_nip}
                                                            readOnly={true}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Tempat/Tanggal Lahir
                                                    </Label>
                                                    <Col md="3">
                                                        <Input
                                                            value={detail.employee?.employee_place_of_birth_city_name ? 
                                                                        detail.employee?.employee_place_of_birth_city_name 
                                                                        : 
                                                                        detail.employee?.employee_place_of_birth_city_text + ', ' + reformatDate(detail.employee?.employee_date_of_birth)
                                                            }
                                                            readOnly={true}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Jenis Kelamin
                                                    </Label>
                                                    <Col md="3">
                                                        <Input
                                                            value={detail.employee?.employee_gender_name}
                                                            readOnly={true}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Agama
                                                    </Label>
                                                    <Col md="3">
                                                        <Input
                                                            value={detail.employee?.employee_religion_name}
                                                            readOnly={true}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Status Kepegawaian
                                                    </Label>
                                                    <Col md="3">
                                                        <Input
                                                            value={detail.employee?.employee_status_name}
                                                            readOnly={true}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Jabatan
                                                    </Label>
                                                    <Col md="3">
                                                        <Input
                                                            value={detail.employee?.employee_current_position_name}
                                                            readOnly={true}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Pangkat (Gol/Ruang)
                                                    </Label>
                                                    <Col md="3">
                                                        <Input
                                                            value={`${detail.employee?.employee_current_work_unit_name} (${detail.employee?.employee_current_rank_group_room})`}
                                                            readOnly={true}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Instansi/Lembaga
                                                    </Label>
                                                    <Col md="3">
                                                        <Input
                                                            value="Badan Koordinasi Penanaman Modal"
                                                            readOnly={true}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Alamat Tempat Tinggal
                                                    </Label>
                                                    <Col md="3">
                                                        <Input
                                                            value={detail.employee?.employee_identity_address}
                                                            readOnly={true}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Nomor Telepon
                                                    </Label>
                                                    <Col md="3">
                                                        <Input
                                                            value={detail.employee?.employee_phone_number}
                                                            readOnly={true}
                                                        />
                                                    </Col>
                                                </Row>
                                                <hr/>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Disamping Jabatan Utama tersebut bekerja pula sebagai
                                                    </Label>
                                                    <Col md="3">
                                                        <AvField 
                                                            name="online_submission_additional_job_name"
                                                            placeholder="Pekerjaan Tambahan..."
                                                            type="textarea"
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Dengan jumlah penghasilan
                                                    </Label>
                                                    <Col md="3">
                                                        <AvField 
                                                            name="online_submission_additional_job_pay"
                                                            placeholder="Penghasilan Tambahan..."
                                                            type="number"
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Mempunyai pensiun/pensiun janda sebesar 
                                                    </Label>
                                                    <Col md="3">
                                                        <AvField 
                                                            name="online_submission_pension"
                                                            placeholder="Uang Pensiun..."
                                                            type="number"
                                                        />
                                                    </Col>
                                                </Row>
                                                {/* <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                    </Label>
                                                    <Col md="3">
                                                        <div className="form-check form-switch mb-3">
                                                            <AvCheckboxGroup name="checkboxExample" onChange={(e, value) => this.setState({ familyAllowance: value?.length > 0 ? true : false })}>
                                                                <AvCheckbox label="Tunjangan Keluarga" value="1"/>
                                                            </AvCheckboxGroup>
                                                        </div>
                                                    </Col>
                                                </Row> */}
                                                <hr/>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Susunan Keluarga
                                                    </Label>
                                                    <Col md="10">
                                                        <AvCheckboxGroup name="online_submission_family_allowance">
                                                        <Table className="table table-striped table-hovered table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th width="5%" className="text-center">No.</th>
                                                                    <th className="text-center">Nama Istri/Suami/Anak</th>
                                                                    <th className="text-center">Tanggal Kelahiran</th>
                                                                    <th className="text-center">Tanggal Perkawinan</th>
                                                                    <th className="text-center">Pekerjaan/ Sekolah</th>
                                                                    <th className="text-center">Keterangan</th>
                                                                    <th className="text-center">Tunjangan</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                { detail.family?.length > 0 ?
                                                                    <Fragment>
                                                                        { detail.family?.map((val, i) => {
                                                                            return (
                                                                                <tr>
                                                                                    <td width="5%">{i+1}</td>
                                                                                    <td>{val.family_name}</td>
                                                                                    <td>{reformatDate(val.family_date_of_birth)}</td>
                                                                                    <td>{reformatDate(val.family_spouse_wedding_date)}</td>
                                                                                    <td>{val.family_profession}</td>
                                                                                    <td>{val.family_relationship_status_name}</td>
                                                                                    <td><AvCheckbox value={val.family_uuid} /></td>
                                                                                </tr>
                                                                            )
                                                                        }) }
                                                                    </Fragment>
                                                                    :
                                                                    <tr>
                                                                        <td colspan="5" className="text-center">Tidak ada data</td>
                                                                    </tr>
                                                                }
                                                            </tbody>
                                                        </Table>
                                                        </AvCheckboxGroup>
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Informasi
                                                    </Label>
                                                    <Col md="10">
                                                        <Alert color="info" role="alert">
                                                            Berdasarkan Surat Edaran Bersama Menteri Keuangan dan Kepala BAKN nomor : SE.I.38/DJA/1.0/7/80 dan nomor 19/SE/1980, bahwa untuk mendapatkan tunjangan keluarga, PNS wajib mengisi dan menyerahkan Surat Keterangan Untuk Mendapatkan Pembayaran Tunjangan Keluarga (KP-4), dengan ketentuan sebagai berikut :<br/>
                                                            <ol>
                                                                <li>Semua CPNS/PNS baik yang menanggung keluarga maupun yang belum menikah WAJIB mengisi dan menyerahkan KP4;</li>
                                                                <li>Bagi CPNS/PNS yang menanggung Istri/Suami yang sama-sama sebagai PNS agar melampirkan daftar rincian gaji dari instansinya;</li>
                                                                <li>Batas usia pemberian tunjangan anak adalah usia 21 tahun dan belum menikah, bagi yang masih sekolah/kuliah tunjangan anak bisa diberikan sampai dengan usia 25 tahun dengan melampirkan surat keterangan masih sekolah/kuliah. Untuk selanjutnya surat keterangan harus diperbaharui setiap tahun.</li>
                                                                <li>Apabila terdapat perubahan jumlah jiwa dalam KP-4, agar melampirkan data pendukung seperti Buku/Akta Nikah, Akta Cerai, Akta Kelahiran anak; Bukti Kelulusan kuliah/sekolah anak; Anak menikah; Suami/Istri/Anak yang meninggal dunia. Hal tersebut dimaksudkan agar tidak terjadi kelebihan pembayaran  tunjangan yang harus dikembalikan kepada Negara.</li>
                                                                <li>Bagi CPNS/PNS yang tidak menyerahkan KP-4, tidak akan dibayarkan tunjangan keluarganya.</li>
                                                            </ol>
                                                        </Alert>
                                                    </Col>
                                                </Row>
                                                <hr/>
                                            </Fragment>
                                        }
                                    </Fragment>
                                }
                                {/* END Pengisian KP4 */}
                                { type != null && this.state.loadingProcess == 0 &&
                                    <Fragment>
                                        {/* <Row className="mb-3">
                                            <Col md="2"></Col>
                                            <Col md="9">
                                                <div className="form-check form-switch mb-3">
                                                    <AvCheckboxGroup name="checkboxExample2" required errorMessage="Agreement harus di centang">
                                                        <AvCheckbox label="Saya yakin dan bertanggung jawab atas data ini" value="1" />
                                                    </AvCheckboxGroup>
                                                </div>
                                            </Col>
                                        </Row> */}
        
                                        <Row className="mb-3">
                                            <Col md="2"></Col>
                                            <Col md="8">
                                                <Link to="/kepegawaian/pengajuan_dokumen.html">
                                                    <Button color="danger" type="button"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                {
                                                    this.state.type != 2 &&
                                                    <Button color="success" type="submit">
                                                        <i className="uil-arrow-up-right"></i> Simpan Data
                                                    </Button>
                                                }
                                            </Col>
                                        </Row>                              
                                    </Fragment>
                                }


                            </AvForm> 
                        </CardBody>
                    </Card>
                </Container>

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/pengajuan_dokumen.html'/>
                : null }


            </Fragment>
        )
    }

}

export default CreateView;